import LaunchIcon from '@mui/icons-material/Launch';
import MailIcon from '@mui/icons-material/Mail';
import React from 'react';

import { isHttpLink, isMailLink } from '../../utils/utils';

interface LinkIconProps {
    link: string;
}

export const LinkIcon: React.FC<LinkIconProps> = ({ link }) => {
    if (!isMailLink(link) && !isHttpLink(link)) {
        return null;
    }

    if (isMailLink(link)) {
        return <MailIcon style={{ fontSize: '0.9rem' }} />;
    }

    return <LaunchIcon style={{ fontSize: '0.9rem' }} />;
};
